// extracted by mini-css-extract-plugin
export default {"form_wraper":"src-pages-rule-pages-detail-index-module_form_wraper--yAZcq"};